import {apiURL, hideSpinner, lowerCaseKeys, makeAppTopMod} from "src/utilities/utilityFunctions";
import axios from 'axios';
import {makeFormData} from "src/utilities/utilityFunctions";
import {
    allLists, inviteSomeoneToTDPAPI,
    obtainplan,
    submitFeatureRating,
    submitPreLaunch
} from "src/services/TDP/APIServices";
import {createDictionary} from "src/utilities/utilityFunctions";
import {obtainMyMediaByList} from "src/services/gameTime/ApiServices";
import store from 'src/store'
import {updateGameTime,updateCurrentActivityData} from "src/actions/gameTime";
import {updateAppSettings} from "src/actions/foundationActions";
import {updateUser} from "src/actions/permissionsActions";
import {updateTDP} from "src/actions/TDPActions";
import {createNewAccount} from "src/services/gameTime/Account/APIServices";
import {showSpinner} from "src/utilities/utilityFunctions";


const showTopNav =[
    "components/TDP/GettingStarted/GettingStarted"
];

export const gameSettings = ()=> {
    store.dispatch(updateGameTime({automaticallyAddTeams:true}));
};

export const inviteSomeoneToTDP = (first,last,email) => {
    showSpinner();
    inviteSomeoneToTDPAPI({firstname:first,lastname:last,email:email},processInviteSomeone,failInviteSomeone)
};

export const processInviteSomeone = (evt) => {
    hideSpinner();
    console.dir(evt);
    if(evt.status===200) {
        store.dispatch(updateTDP({membershipSubscriptionSuceess: true}));
    }

};

export const failInviteSomeone = (evt) =>{
    hideSpinner();
    console.dir(evt);
};




export const newAccount = (first,last,email,password) => {
    createNewAccount({firstname:first,lastname:last,email:email,password:password},processNewAccount,failNewAccount)
};

export const obtainAllLists = () => {
    allLists({},processAllLists,failAllLists);
};

const processAllLists = (evt) => {
    console.dir("Lists!");
    let res = evt.data.lists;
    console.dir(res);
    let resDict = createDictionary(res,"mylistid");
    store.dispatch(updateGameTime({TDPLists:res,TDPListDictionary:resDict}));
};

const failAllLists = (evt) => {
    console.dir(evt);
};

export const sendMessage =  (name,email,subject,body,site,callBack) => {
    axios.post(apiURL() + "/kimclassroom/contact",makeFormData({name:name,email:email,subject:subject,body:body,site:site}),
        {headers:{"contactustoken":"738DBE5A-7411-480B-91D4CC80F198DFB8"}})
        .then(callBack);
};



export const obtainMediaForList = (listid) => {
    obtainMyMediaByList(listid,processMediaForList,failMediaForList);
};

const processMediaForList = (evt) => {
    let stateData = store.getState();
    let res=lowerCaseKeys(evt.data);
    let listid=evt.data[0].mylistid;
    let listDict = Object.assign({},stateData.gameTime.TDPListDictionary);
    listDict[listid].listItems = res;
    store.dispatch(updateGameTime({TDPListDictionary: listDict,currentList:listDict[listid],currentListItems:([]).concat(res)}));
};

const failMediaForList = (evt) => {
    console.dir(evt)
};

export const setDancePartyRole = (role) => {
    store.dispatch(updateAppSettings({playerMode:role}));
};

/*
export const enterRoomAsGuest = (props) => {
    props.updateAppSettings({appMainModuleName:"components/gameTimeMyRoom/MyRoom"});
    props.updateGameTime({activeRoom:{roomid:"BE8B7B16-C9F0-407A-BB17856692EFC443",
            peopletoroomrole:"guest",roomname:"Yo Diggity",ownerfirstname:"My"}});
};

export const enterRoomAsEmcee = (props) => {
    makeEmcee(props,props.webSocketData.clientid);
    props.updateAppSettings({appMainModuleName:"components/gameTimeMyRoom/MyRoom"});
    props.updateGameTime({activeRoom:{roomid:"BE8B7B16-C9F0-407A-BB17856692EFC443",
            peopletoroomrole:"emcee",roomname:"Yo Diggity",ownerfirstname:"My"}});
};
export const enterRoomAsHost = () => {

};
*/
export const checkForListMedia = (list) => {
    let storeData = store.getState();
    list = list ? list : storeData.gameTime.TDPListFocus;
    if(!storeData.gameTime.TDPListDictionary[list] || !storeData.gameTime.TDPListDictionary[list].hasOwnProperty("listItems")){
        //obtainMediaForList(props,list)
        obtainMyMediaByList(list,processMediaForList,failMediaForList);
    }
};

export const playListInRoom = (list) => {
    let stateData = store.getState();
    let role = stateData.gameTime.userMode === 'child' ? "host" : "guest";
    store.dispatch(updateAppSettings({appMainModuleName:"components/gameTimeMyRoom/MyRoom",showDefaultModal:false}));
    store.dispatch(updateCurrentActivityData({playListIndex:0,currentActivityName:"components/gameTimePlayList/PlayList"}));
    store.dispatch(updateGameTime({currentList:list,
        currentListItems: list.listItems,
        activeRoom:{roomid:"BE8B7B16-C9F0-407A-BB17856692EFC443",peopletoroomrole:role,roomname:"Yo Diggity",ownerfirstname:"My"}}));
};

export const playListInModal = (props,list) => {
    let role = props.gameTime.userMode === 'child' ? "host" : "guest";
    props.updateCurrentActivityData({playListIndex:0,currentActivityName:"components/gameTimePlayList/PlayList"});
    props.updateGameTime({
        currentList:list,
        currentListItems: list.listItems,
        activeRoom:{roomid:"BE8B7B16-C9F0-407A-BB17856692EFC443",peopletoroomrole:role,roomname:"Yo Diggity",ownerfirstname:"My"}});
    props.updateAppSettings({
       modalModuleName:"components/gameTimeMyRoom/MyRoom",
       showDefaultModal:true
    });
};

export const calcDuration = (lister) => {
    let dur =  lister.listItems ? lister.listItems.reduce((len,item) => {
        return item["mymediaduration"] !=='' && !isNaN(item["mymediaduration"]) ?  parseInt(len) + parseInt(item["mymediaduration"]) : parseInt(len);
    },0) : [];
    return durationToDisplay(dur);
};

export const durationToDisplay = (dur) => {
    return Math.floor(parseInt(dur)/60) + "m " + (parseInt(dur) % 60) + "s";
};

export const openTDPApp = (mod,activity,hostmod,hideTopNav=true) => {
    makeAppTopMod(mod);
    let appEt = {hideTopNav:showTopNav.indexOf(mod) ===-1};
    if(hostmod){appEt.myRoomModalComponentName = hostmod}
    store.dispatch(updateAppSettings(appEt));
    store.dispatch(updateCurrentActivityData({ currentActivityName:activity}));
};

export const obtainSubscription = (props) => {
    obtainplan(props,processPlan,failPlan);
};

const processPlan = (props,evt) => {
    props.updateGameTime(lowerCaseKeys(evt.data));
    //console.dir(evt);
};

const failPlan = (props,evt) => {
    console.dir(evt);
};

export const startMonitor = () =>{
    store.dispatch(updateCurrentActivityData({chatWidth:6, activityWidth:6}));

};

export const makeTDPRoom = () => {
    let room = Object.assign({},store.getState().gameTime["myRoomDict"]["TDP"]);
    //console.dir("room");
    //console.dir(room);
    room.peopletoroomrole = "host";
    store.dispatch(updateGameTime({activeRoom:room}));
};

export const sendPreLaunchInterest = (props,first,last,email,comments) => {
    submitPreLaunch(props,{first:first,last:last,email:email,comments:comments},processPreLaunch,failPreLaunch);
};

export const processPreLaunch = (props,evt) => {
    console.dir(evt);
};

export const failPreLaunch = (props,evt) => {
    console.dir(evt)
};

export const submitFeatureFeedback = (vote,feature,audience) =>{
    submitFeatureRating({vote:vote,feature:feature,audience:audience},processFeedback,failFeedback )
};

const processFeedback = (props,evt) => {
    hideSpinner();
    console.dir("Back");
    console.dir(evt);
};

const failFeedback = (props,evt) => {
    hideSpinner();
    console.dir("fail");
    console.dir(evt);
};

export const checkedEmail = (evt) => {
    hideSpinner();
    store.dispatch(updateTDP({newEmailUnique:true}))
};

export const failEmail = (evt) => {
    hideSpinner();
    store.dispatch(updateTDP({newAccountError:true}))
};

export const processNewAccount = (evt) => {
    hideSpinner();
    if(evt.status===200 && evt.data.hasOwnProperty("person")){
        store.dispatch(updateUser(lowerCaseKeys(evt.data.person)));
        store.dispatch(updateGameTime({account:lowerCaseKeys(evt.data.account)}));
        store.dispatch(updateTDP({newAccountMade:true}))
    }
    if(evt.data.STATUS===500){
        store.dispatch(updateAppSettings({userMessage:evt.data.MESSAGE}));
        setTimeout(()=>{store.dispatch(updateAppSettings({userMessage:""}))},5000)
    }
};

export const failNewAccount = (evt)=> {
    hideSpinner();
    if(evt.data.STATUS===500){
        store.dispatch(updateAppSettings({userMessage:evt.data.MESSAGE}));
    }
};

export const setPlayAs = (item) => {
    store.dispatch(updateTDP({playAs:Object.assign({},item)}));
    store.dispatch(updateUser(Object.assign({},store.getState().user,{firstname:item.firstname})))
};
